var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlidingPagination',{staticClass:"journal-lpo__pagination",attrs:{"current":_vm.currentPage,"total":_vm.totalPages},on:{"page-change":_vm.onPageChange}})}
var staticRenderFns = []

export { render, staticRenderFns }